/**
 * emails invoice pdf to recipients
 * @param firebase
 * @param payload
 * @returns {Promise<HttpsCallableResult>}
 */
export async function emailInvoice({ firebase }, payload) {
  const call = firebase.functions().httpsCallable("emailInvoice");
  return await call(payload);
}
